import React, { useContext, useState, useRef, useEffect } from "react";
import { Box, Text, TextInput, Tip, Header, Image, DateInput, Button, Layer, Select, CheckBox} from "grommet";
import { ThemeContext } from 'grommet/contexts';
import WarningPopupWindow from "../Base components/WarningPopupWindow";
import { FormEdit, FormUp, FormDown } from "grommet-icons";
import { correctTimeZone, generateSyncId, sheetStatus, updateStateHandler } from "../Utils/Utils";
import { getPhenologicalStageOptions } from "../Utils/RBGUtils";

const TreatmentTable = (props) => {
    const {  treatmentValues, setTreatmentValues, templatesComboList, selectedTemplate, onChangeSelected,
            disable, newTreatment, baseTreatmentTemplate, setHasEdit,
            tableWdth, tableHeight, isDefault, treatmentProperties, stateHandler
        } = props;

    const theme = useContext(ThemeContext);
    const [show, setShow] = useState(false);
    const [newTreatmentvalue, setNewTreatmentvalue] = useState("");

    // console.log('props.treatmentID >> ', treatmentID);
    // console.log('In TreatmentTable treatmentValues >> ', treatmentValues);

    const [showWarning, setShowWarning] = useState(false);
    const [warningMessage, setWarningMessage] = useState('');   


    // console.log('In TreatmentTable props obj:', props);
    // console.log('newTreatment >> ', newTreatment);
    // console.log('props.disable >> ', props.disable);

    let statusString = "";
    if (!isDefault) {
        const sheetStatusObj = sheetStatus.find(obj => obj.hasOwnProperty(treatmentProperties.StatusID));
        statusString = sheetStatusObj ? sheetStatusObj[treatmentProperties.StatusID] : "";
    }  

    const closeWarning = () => {
        setShowWarning(false);
        setWarningMessage('');
    }

    // Function gets ISO date string and convert it to format "dd/mm/yyyy"
    const getDateString = (dateVal) => {
        return  dateVal ? dateVal.split('T')[0].split("-").reverse().join("/") : '';
    }

    const getMaxOrderByValue = () => {
        const orderByMax = 0; // Define a default value for orderByMax if needed

        if (Array.isArray(treatmentValues) && treatmentValues.length > 0) {
            const maxOrder = treatmentValues.reduce((max, element) => {
                return Number(element.OrderBy) > max ? Number(element.OrderBy) : max;
            }, orderByMax);
            return maxOrder + 1;
        } else {
            return 1; // If there are no treatmentValues, return 1
        }
    }    

    const onStageChange = (label, newValue) => {
        // console.log('new value >> ', newValue);
        // console.log('label >> ', label);
        // console.log('new treatmentValues >> ', treatmentValues);

        newValue = newValue === '' ? null : newValue;

        setTreatmentValues((prevState) => {
            const updatedValues = prevState.map((el) =>
                el.LabelName === label ? { ...el, PhenologicalStageNum: newValue, LastSyncDate: correctTimeZone(new Date()) } : el
            );
        
            if (setHasEdit) {
                const isValueChanged = JSON.stringify(updatedValues) !== JSON.stringify(prevState);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }
        
            return updatedValues;
        });


        if (newTreatment && 
            (treatmentProperties.TreatmentName === selectedTemplate.TreatmentName || 
             treatmentProperties.TreatmentName === '' )) {
                 updateStateHandler(stateHandler, "TreatmentName", "Custom"); 
         }
    };    

    
    const onDateChange = (label, newValue) => {
        // console.log('new value before >> ', newValue);
        newValue = newValue === undefined ? null : correctTimeZone(newValue);
        // console.log('new value after  >> ', newValue);

        setTreatmentValues((prevState) => {
            const updatedValues = prevState.map((el) =>
                el.LabelName === label ? { ...el, Date: newValue, LastSyncDate: correctTimeZone(new Date()) } : el
            );

            if (setHasEdit) {
                const isValueChanged = JSON.stringify(updatedValues) !== JSON.stringify(prevState);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }
            return updatedValues;
        });

        if (newTreatment && 
           (treatmentProperties.TreatmentName === selectedTemplate.TreatmentName || 
            treatmentProperties.TreatmentName === '' )) {
                updateStateHandler(stateHandler, "TreatmentName", "Custom"); 
        }
    };

    const onProductChange = (label, newValue) => {
        // console.log('new value >> ', newValue);
        // console.log('label >> ', label);
      
        setTreatmentValues((prevState) => {
            const updatedValues = prevState.map((el) =>
                el.LabelName === label ? { ...el, Product: newValue, LastSyncDate: correctTimeZone(new Date()) } : el
            );
  
            if (setHasEdit) {
                const isValueChanged = JSON.stringify(updatedValues) !== JSON.stringify(prevState);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }
            return updatedValues;
        });

        if (newTreatment && 
            (treatmentProperties.TreatmentName === selectedTemplate.TreatmentName || 
             treatmentProperties.TreatmentName === '' )) {
                 updateStateHandler(stateHandler, "TreatmentName", "Custom"); 
        }
    };
    
    const onDoseChange = (label, newValue) => {
        // console.log('new value >> ', newValue);
        // console.log('label >> ', label);
      
        setTreatmentValues((prevState) => {
            const updatedValues = prevState.map((el) =>
                el.LabelName === label ? { ...el, Dose: newValue, LastSyncDate: correctTimeZone(new Date()) } : el
            );
    
            if (setHasEdit) {
                const isValueChanged = JSON.stringify(updatedValues) !== JSON.stringify(prevState);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }

            return updatedValues;
        });

        if (newTreatment && 
            (treatmentProperties.TreatmentName === selectedTemplate.TreatmentName || 
             treatmentProperties.TreatmentName === '' )) {
                 updateStateHandler(stateHandler, "TreatmentName", "Custom"); 
        }
    };

    const onOrderChange = (label, newValue) => {
        console.log('new value >> ', newValue);
        console.log('label >> ', label);

        // Check if there is an object with the same Order
        if (treatmentValues.some((tv) => tv.OrderBy === Number(newValue))) {
            //console.log(`Treatment value with label "${newTreatmentvalue}" already exists.`);
            setWarningMessage(`Treatment stage with order "${newValue}" already exists.`);
            setShowWarning(true);
            return;
        }

        setTreatmentValues((prevState) => {
            const updatedValues = prevState.map((el) =>
                el.LabelName === label ? { ...el, OrderBy: newValue } : el
            );  

            if (setHasEdit) {
                const isValueChanged = JSON.stringify(updatedValues) !== JSON.stringify(prevState);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }

            return updatedValues;
        });
    };

    const onMoveUp = (labelName) => {
        setTreatmentValues((prevValues) => {
            const index = prevValues.findIndex(item => item.LabelName === labelName);
            if (index === -1 || index === 0) return prevValues; // Already at the top or not found
    
            const newValues = prevValues.map((item, idx) => {
                if (idx === index) {
                    return { ...item, OrderBy: prevValues[index - 1].OrderBy };
                } else if (idx === index - 1) {
                    return { ...item, OrderBy: prevValues[index].OrderBy };
                } else {
                    return item;
                }
            });
    
            if (setHasEdit) {
                const isValueChanged = JSON.stringify(newValues) !== JSON.stringify(prevValues);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }

            return newValues.sort((a, b) => a.OrderBy - b.OrderBy);
        });
    };
    
    const onMoveDown = (labelName) => {
        setTreatmentValues((prevValues) => {
            const index = prevValues.findIndex(item => item.LabelName === labelName);
            if (index === -1 || index === prevValues.length - 1) return prevValues; // Already at the bottom or not found
    
            const newValues = prevValues.map((item, idx) => {
                if (idx === index) {
                    return { ...item, OrderBy: prevValues[index + 1].OrderBy };
                } else if (idx === index + 1) {
                    return { ...item, OrderBy: prevValues[index].OrderBy };
                } else {
                    return item;
                }
            });

            if (setHasEdit) {
                const isValueChanged = JSON.stringify(newValues) !== JSON.stringify(prevValues);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }
    
            return newValues.sort((a, b) => a.OrderBy - b.OrderBy);
        });
    };
    
    const onDefaultChange = (label) => {
        setTreatmentValues((prevState) => {
            const updatedValues = prevState.map((el) =>
                el.LabelName === label ? { ...el, IsDefaultField: el.IsDefaultField === 1 ? 0 : 1 } : el
            );

            if (setHasEdit) {
                const isValueChanged = JSON.stringify(updatedValues) !== JSON.stringify(prevState);
                if (isValueChanged) {
                    setHasEdit(true);
                }
            }

            return updatedValues;
        });
    };  
    
    const onTreatmentNameChange = (newName) => {
        // console.log('treatmentName   ', treatmentProperties.treatmentName);
        if (treatmentProperties.treatmentName === newName)
            return;        

        updateStateHandler(stateHandler, "TreatmentName", newName);
        setHasEdit(true);
    };

    const addTreatmentValue = () => {
        if (newTreatmentvalue === ""){
            //console.log(`Empty stage can't be added.`);
            setWarningMessage(`Empty stage can't be added.`);
            setShowWarning(true);
            return;
        }

        // Check if there is an object with the same LabelName
        if (treatmentValues.some((tv) => tv.LabelName.toLowerCase() === newTreatmentvalue.toLowerCase())) {
            //console.log(`Treatment value with label "${newTreatmentvalue}" already exists.`);
            setWarningMessage(`Treatment value with label "${newTreatmentvalue}" already exists.`);
            setShowWarning(true);
            return;
        }

        const orderByMax = getMaxOrderByValue();
        const length = 30;
        var trimmedString = newTreatmentvalue.substring(0, length);

        const newValue = {
            TreatmentValueID: generateSyncId(),
            TreatmentID: treatmentProperties.TreatmentID,
            PhenologicalStageNum: null,   
            LabelName: trimmedString.trim(),
            Date: null,
            Product: null,
            Dose: null,
            OrderBy: orderByMax,
            IsDefaultField: isDefault ? 1 : undefined,
            LastSyncDate: !isDefault ? correctTimeZone(new Date()) : undefined,
        };

        setTreatmentValues((prevState) => [
            ...prevState,
            { ...newValue, key: Date.now() }
        ]);

        setNewTreatmentvalue("");


        if (newTreatment && 
            (treatmentProperties.TreatmentName === selectedTemplate.TreatmentName || 
             treatmentProperties.TreatmentName === '' )) {
                 updateStateHandler(stateHandler, "TreatmentName", "Custom"); 
        }

        if (setHasEdit) {
            setHasEdit(true);
        }
    };

    const DrawTable = () => {
        if (!treatmentValues || treatmentValues.length === 0) {
            return null;
        }
        return treatmentValues.map((item, index) => DrawRow(item, index));
    };



    const DrawRow = (treatmentVal, index) => {
        return (
            <Box
                key={treatmentVal.LabelName+index}
                direction="row"
                align="center"
                justify="between"
                style={{ minHeight: "30px" }}
            >
                <Box width="150px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }}>
                    <Text color="brand">{treatmentVal.LabelName}</Text>
                </Box>
    
                <Box width="280px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }}>
                    {!disable ?
                        <Select
                            value={treatmentVal.PhenologicalStageNum === null ? 0 : treatmentVal.PhenologicalStageNum}
                            valueKey={{ key: "index", reduce: true }}
                            labelKey="value"
                            placeholder="Select..."
                            style={{ padding: "3px 0 3px 10px" }}
                            options={getPhenologicalStageOptions()}
                            onChange={(event) => onStageChange(treatmentVal.LabelName, event.value)}
                            emptySearchMessage={"No Stage Avail"}
                            clear
                        />
                        :
                        <TextInput
                            style={{ padding: "3px 0 3px 10px", fontSize: "large" }}
                            value={getPhenologicalStageOptions().find(option => option.index === treatmentVal.PhenologicalStageNum)?.value || ''}
                            readOnly={disable === undefined ? false : disable}
                            disabledKeyboardNavigation
                        />
                    }
                </Box>
    
                {!isDefault && (
                    <Box width="160px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }}>
                        {!props.disable ?
                            <DateInput
                                format="dd/mm/yyyy"
                                value={treatmentVal.Date ? treatmentVal.Date : ""}
                                style={{ padding: "3px 0 3px 10px" }}
                                onChange={(event) => onDateChange(treatmentVal.LabelName, event.value)}
                                calendarProps={{ size: 'small' }}
                            />
                            :
                            <TextInput
                                style={{ padding: "3px 0 3px 10px", fontSize: "large" }}
                                value={getDateString(treatmentVal.Date)}
                                readOnly={disable === undefined ? false : disable}
                                disabledKeyboardNavigation
                            />
                        }
                    </Box>
                )}
                
                <Box width="150px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }}>
                    <TextInput
                        value={treatmentVal.Product ? treatmentVal.Product : ""}
                        style={{ padding: "3px 0 3px 10px" }}
                        readOnly={props.disable === undefined ? false : props.disable}
                        onChange={(event) => onProductChange(treatmentVal.LabelName, event.target.value)}
                    />
                </Box>
    
                <Box width="80px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }}>
                    <TextInput
                        value={treatmentVal.Dose ? treatmentVal.Dose : ""}
                        style={{ padding: "3px 0 3px 10px" }}
                        readOnly={props.disable === undefined ? false : props.disable}
                        onChange={(event) => onDoseChange(treatmentVal.LabelName, event.target.value)}
                    />
                </Box>
    
                {isDefault && (
                    <>
                        <Box width="60px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }}>
                            <TextInput
                                value={treatmentVal.OrderBy ? treatmentVal.OrderBy : ""}
                                style={{ padding: "3px 0 3px 10px" }}
                                onChange={(event) => onOrderChange(treatmentVal.LabelName, event.target.value)}
                                readOnly
                            />
                        </Box>
    
                        <Box width="40px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }} align="center" justify="around">
                            <Box
                                width="20px"
                                height="12px"
                                align="center"
                                justify="center"
                                background="#DADADA"
                                margin="2px"
                                onClick={() => index > 0 && onMoveUp(treatmentVal.LabelName)}
                                style={{ opacity: index === 0 ? 0.5 : 1, cursor: index === 0 ? 'not-allowed' : 'pointer' }}
                            >
                                <FormUp />
                            </Box>
                            <Box
                                width="20px"
                                height="12px"
                                align="center"
                                justify="center"
                                background="#DADADA"
                                margin="2px"
                                onClick={() => index < treatmentValues.length - 1 && onMoveDown(treatmentVal.LabelName)}
                                style={{ opacity: index === treatmentValues.length - 1 ? 0.5 : 1, cursor: index === treatmentValues.length - 1 ? 'not-allowed' : 'pointer' }}
                            >
                                <FormDown />
                            </Box>
                        </Box>
    
                        <Box width="40px" pad={{ vertical: "xsmall", horizontal: "xxsmall" }}>
                            <CheckBox
                                checked={treatmentVal.IsDefaultField === 1}
                                onChange={() => onDefaultChange(treatmentVal.LabelName)}
                            />
                        </Box>
                    </>
                )}
            </Box>
        );
    };
    
 
    //Add horizontal scroll with mouse wheel on specific area
    document.addEventListener("DOMContentLoaded", function () {
        add_horizontal_scroll();
    });
    
    function add_horizontal_scroll() {
        const scrollContainer = document.querySelector(".horizontal-scroll");
        scrollContainer.addEventListener("wheel", (evt) => {
            evt.preventDefault();
            scrollContainer.scrollLeft += evt.deltaY;
        });
    }

    return (
        <>
        {showWarning && (
            <WarningPopupWindow msg={warningMessage} close={closeWarning}/>
        )}
        {/* table */}
        <Box 
            height={tableHeight} 
            width={tableWdth} 
            >
            {/* Top part fixed */}
            <Box 
                style={{
                    position: 'sticky',
                }}
                >
                <Box margin={{vertical: "large"}} alignSelf="center" >
                {isDefault ? 
                        <Tip  
                        content={<Box style={{background: "rgba(204, 204, 204, .6)", padding: "2px",  borderRadius: "6px", color: "#76b9cf", fontSize: "14px"}}>
                        You can change treatment name
                        </Box>}
                        plain
                    >
                    <TextInput 
                        style={{ 
                            border: "none", 
                            borderRadius: 0, // Ensure there are no rounded corners on the input
                            width: "200px",
                            textDecoration: "2px underline",
                            letterSpacing: "2px", // Adjust the spacing between letters
                            fontStyle: "italic", // Italicize the text
                            fontSize: "26px",
                            background: 
                                treatmentProperties.TreatmentName.toLowerCase() === baseTreatmentTemplate.TreatmentName.toLowerCase() 
                                    || treatmentProperties.TreatmentName === '' ? "#f5f5f5" : "transparent"
                        }}

                        value={treatmentProperties.TreatmentName.toLowerCase() === baseTreatmentTemplate.TreatmentName.toLowerCase() ? '' : treatmentProperties.TreatmentName}
                        onChange={(event) => onTreatmentNameChange(event.target.value)} // Ensure the input value is updated
                        data-tip="You can change it" // Add this line for react-tooltip
                        data-for="textInputTooltip"
                    />
                    </Tip>
                    :
                    <Text alignSelf="center" color="brand" size="22px" 
                        style={{ borderBottom: `2px solid ${theme.global.colors.brand}` }}
                     >
                    Treatment/Phenological stage:
                    </Text>
                }
                </Box>
                

                <Box style={{ position: "absolute", left: "3%", top: "5px" }} >
                    {(templatesComboList.length > 0 && (newTreatment || isDefault)) && 
                    <Select
                        value={selectedTemplate.TreatmentName}
                        valueKey={{key: "TreatmentName", reduce: true }}
                        labelKey="TreatmentName"
                        placeholder="Select Template..."
                        style={{padding: "5px 0 5px 10px", width: "170px"}} 
                        options={templatesComboList}            
                        onChange={({option}) => onChangeSelected(option)}                         
                        emptySearchMessage={"No Templates Available"} 
                        clear                                  
                    />
                    }
                </Box>

                <Box style={{ position: "absolute", right: "3%", top: "5px" }} >
                    <Text alignSelf="center" color="#73182f" size="large" weight="bold">
                            {statusString}
                        </Text>
                    </Box>        
                </Box>


            <Box fill
                style={{
                    overflowX: 'auto',
                    margin: 'auto',
                    padding: '5px',
                }}           
            >

            <Box fill
                style={{
                    margin: 'auto',
                    width: '800px',
                    maxWidth:"none"
                }}           
            >
                    <Box
                        direction="row" justify="between" 
                        border={{ side: 'bottom', color: 'brand' }}
                        margin={{ bottom: "xxsmall" }}
                        style={{
                            position: 'sticky',
                            top: '0',
                            zIndex: 1,
                            textAlign: 'left',
                            whiteSpace: 'nowrap',
                        }}               
                    >    
                   
                        <Box pad="xsmall" width="150px" >
                            <Text color="brand" ></Text> 
                        </Box> 
                        <Box pad={{ top: "xsmall", bottom: "none" }} width="280px" >
                            <Text color="brand">Stage</Text> 
                        </Box> 
                        { (!isDefault) &&  
                        <Box pad="xsmall" width="160px" >
                            <Text color="brand">Date</Text> 
                        </Box>
                        }  
                        <Box pad={{ vertical: "xsmall" }} width="150px" >
                            <Text color="brand">Product</Text> 
                        </Box>   
                        <Box  pad="xsmall" width="80px" >
                            <Text color="brand">Dose</Text> 
                        </Box>


                        {isDefault && (
                        <>
                            <Box  pad="xsmall" width="60px" >
                                <Text color="brand">Order</Text> 
                            </Box>
                            <Box  pad="xsmall" width="40px" >
                            </Box>
                            <Box  pad="xsmall" width="40px" >
                                {/* <Text color="brand">Default</Text>  */}
                            </Box>
                        </>                           
                        )}
                    </Box>

                    {/* Middle part scrollable */}
                    <Box flex overflow='auto'>
                        {DrawTable()}
                    </Box>
                </Box>
            </Box>

            {/* Bottom part fixed */}
            <Box
                margin="0 auto"
                pad={{ vertical: "small" }}
                width='800px'
                border={{ side: 'top', color: 'brand' }}
                style={{
                    position: 'sticky',
                    zIndex: 1,
                }}
            >
                <Box 
                    style={{ position: "absolute", right: "3%", bottom: '-30px', }}>                
                    <Button secondary
                        icon={<FormEdit />}
                        label="Add"
                        style={{ color: `${theme.global.colors.brand}`, fontWeight: "bold"}}
                        onClick={() => {
                            setShow(true);
                        }}
                        hoverIndicator
                        disabled={props.disable === undefined ? false : props.disable}
                        />
                </Box>
                
            </Box> 
 
 
            {show && (
                <Layer
                    id="newstage"
                    position="center"
                    modal
                    // style={{
                    //     backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
                    // }}
                >
                    <Box pad="small" margin="small" gap="small" width="medium" 
                        background="#ebf8fc" 
                        border>

                        <Box style={{position:"relative"}}>
                            <Header margin="none" background="light-4" pad="small" height="xxsmall" justify="around">
                                <Text alignSelf="start" color="brand" size="large"  align="center" >
                                    <strong>Confirm</strong>
                                </Text>
                            </Header>
                            <Box height="xsmall" width="xsmall"  
                                style={{position:"absolute", right: "3%", top: "15px"}}
                                right="0px"
                                >
                                    <Image
                                        size="contain"
                                        src="Grape.png"                                  
                                    />
                            </Box>                 
                        </Box>

                        <Box align="center" margin={{top: 'medium'}}>                                    
                            <Text  margin="large" textAlign="center" ><span style={{whiteSpace: 'pre-line'}}><strong>Add new stage:</strong></span></Text>
                            <Box  width="80%" >
                                <TextInput                  
                                    style={{ padding: "1px 5px", background: "white"}} 
                                    onBlur={(event) => {                     
                                        setNewTreatmentvalue(event.target.value);
                                    }} 
                                />  
                            </Box>  
                        </Box>
                        <Box
                            as="footer"
                            gap="small"
                            direction="row"
                            align="center"
                            justify="around"
                            pad={{ top: 'medium', bottom: 'small' }}
                        >
                            <Button
                                label={
                                    <Text color="white">
                                        <strong>Ok</strong>
                                    </Text>
                                }                
                                onClick={() => {
                                    setShow(false);
                                    addTreatmentValue();
                                }}
                                primary                  
                            />  

                            <Button
                                label={
                                    <Text color="brand">
                                        <strong>Cancel</strong>
                                    </Text>
                                }              
                                onClick={() => {
                                    setShow(false);
                                }}
                            />                      
                        </Box>
                    </Box>
                </Layer>
                )}

        </Box>
        </>
    );
};

export default TreatmentTable;

